import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CompanyControllingPersonModel } from '@data-layer/models/companies';
import { identifierSSNValidator } from '@helpers/custom-validator';

// #13269 — one controlling person (beneficial owner / partner) section on the company profile.
// id 0 means "create on next PUT"; validators are cleared dynamically when the business type needs no persons.
// Deliberately DI-free: CompaniesService builds these too, and injecting FormHelper there creates
// a DI cycle (CompaniesService → FormHelper → DateTimezoneService → CompaniesService, NG0200).
export const createControllingPersonFormGroup = (person?: CompanyControllingPersonModel): UntypedFormGroup =>
  new UntypedFormGroup({
    id: new UntypedFormControl(person && person.id ? person.id : 0),
    firstName: new UntypedFormControl(person ? person.firstName : null, [Validators.required]),
    lastName: new UntypedFormControl(person ? person.lastName : null, [Validators.required]),
    socialSecurityNumber: new UntypedFormControl(person ? person.socialSecurityNumber : null, [
      Validators.required,
      identifierSSNValidator(),
    ]),
    isUsCitizenOrResident: new UntypedFormControl(!!person && !!person.isUsCitizenOrResident, [Validators.requiredTrue]),
  });
